import './App.css';
import MazeGeneratorVisualizer from "./MazeGeneratorVisualizer/MazeGeneratorVisualizer.jsx";


function App() {
  return (
    <div className="App">
      <MazeGeneratorVisualizer></MazeGeneratorVisualizer>
    </div>
  );
}

export default App;
